import { render, staticRenderFns } from "./TaskCalendar.vue?vue&type=template&id=7e45c2d0&scoped=true&"
import script from "./TaskCalendar.vue?vue&type=script&lang=js&"
export * from "./TaskCalendar.vue?vue&type=script&lang=js&"
import style0 from "./TaskCalendar.vue?vue&type=style&index=0&id=7e45c2d0&prod&lang=scss&scoped=true&"
import style1 from "./TaskCalendar.vue?vue&type=style&index=1&id=7e45c2d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e45c2d0",
  null
  
)

export default component.exports